import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { isNullOrEmpty } from '@awp/core/utils';
import { ThemeService } from './theme.service';

@Injectable({
  providedIn: 'root',
})
export class ThemeGuard implements CanActivate {

  constructor(
    private router: Router,
    private themeService: ThemeService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | UrlTree {
    const themeId = route.paramMap.get('themeId');
    if (isNullOrEmpty(themeId)) {
      return this.router.createUrlTree(['page/not-found']);
    }

    return this.themeService.verifyTheme(themeId.toLowerCase())
      .pipe(
        map(p => {
          if (p == null || p === false) {
            return this.router.createUrlTree(['page/not-found']);
          }
          this.themeService.setTheme(themeId.toLowerCase());
          return true;
        })
      );
  }
}
